import { render, staticRenderFns } from "./k-field-time.vue?vue&type=template&id=5242a088"
import script from "./k-field-time.vue?vue&type=script&lang=js"
export * from "./k-field-time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports